import { APPS } from "@creditas/home-mf-shared";

export const getAppNameByPathname = () =>
  Object.keys(APPS).find(function (appName) {
    return window.location.pathname.startsWith(APPS[appName].route);
  });
